import { View, StyleSheet } from '@react-pdf/renderer';
import { theme } from '../theme';

const style = StyleSheet.create({
  pdfTableStyle: {
    width: '100%',
    marginBottom: '10px',

    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.colors.primaryK1}`,
  },
});

export const PdfTable: React.FC<{ wrap?: boolean }> = ({ wrap, ...props }) => (
  <View style={style.pdfTableStyle} wrap={false}>
    {props.children}
  </View>
);
